import { StackClientApp } from '@stackframe/react';

const projectId = import.meta.env.VITE_STACK_PROJECT_ID;
const publishableClientKey = import.meta.env.VITE_STACK_PUBLISHABLE_CLIENT_KEY;

if (!projectId || !publishableClientKey) {
  // eslint-disable-next-line no-console
  console.warn(
    '[stack] VITE_STACK_PROJECT_ID / VITE_STACK_PUBLISHABLE_CLIENT_KEY not set — auth will not work.',
  );
}

export const stackApp = new StackClientApp({
  projectId: projectId ?? 'unset',
  publishableClientKey: publishableClientKey ?? 'unset',
  tokenStore: 'cookie',
  urls: {
    home: '/',
    signIn: '/handler/sign-in',
    afterSignIn: '/',
    afterSignOut: '/handler/sign-in',
  },
});
